import { useEffect, useState } from "react";
import { useParams, Link, useNavigate, useLocation } from "react-router";
import { Spinner } from "../../SharedModule/components/Spinner";
import {
  ROUTE_CLIENTS,
  ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACT_DETAILS,
  ROUTE_CLIENTS_RELATIONSHIP_REVIEW,
} from "../../SharedModule/utils/constants";
import { BiLeftArrowAlt } from "react-icons/bi";
import { ClientsService } from "../services/clients";
import { Client, ConfidenceHistory } from "../types/clients-module-types";
import { PaginatedItems } from "../../SharedModule/components/PaginatedItems";
import { useDispatch, useSelector } from "react-redux";
import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import HeaderClientsModule from "../components/HeaderClientsModule";
import {
  SelectActualClientForHeaderInfo,
  setActualClientForHeaderInfo,
  setIsActualClientForHeaderInfoLoading,
} from "../redux/reducers/clientsList.reducer";
import { resetScrollY } from "../../SharedModule/utils/pagesUtils";

export const ClientConfidenceHistoryPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  let { id, relationshipReviewId, keyContactId } = useParams();

  // To check is header info is already loaded
  const ClientForHeaderInfo: Client = useSelector(
    SelectActualClientForHeaderInfo
  );

  let initialState: ConfidenceHistory[] = [];

  const [confidenceHistory, setConfidenceHistory] = useState(initialState);
  const [isLoadingDataConfidence, setIsLoadingDataConfidence] = useState(true);
  const [hasConfidenceHistory, setHasConfidenceHistory] = useState(false);

  const loadHeaderInfo = async (clientId: number) => {
    dispatch(setIsActualClientForHeaderInfoLoading(true));
    await ClientsService.getClientModuleHeaderInfo(Number(keyContactId))
      .then((response) => {
        dispatch(setActualClientForHeaderInfo(response.data));
      })
      .catch(() => {
        dispatch(
          addToast({
            mode: "error",
            message:
              "Something wrong happened while getting the client header information.",
          })
        );
        dispatch(setIsActualClientForHeaderInfoLoading(false));
        navigate(ROUTE_CLIENTS);
      });
  };

  const loadConfidenceHistory = async () => {
    await ClientsService.getKeyContactConfidenceHistory(Number(keyContactId))
      .then((response) => {
        if (response && response.data.length > 0) {
          setConfidenceHistory(response.data);
          setHasConfidenceHistory(true);
          setIsLoadingDataConfidence(false);
        }
      })
      .catch(() => {
        dispatch(
          addToast({
            mode: "error",
            message:
              "Something wrong happened while getting the key contact confidence history info.",
          })
        );
        navigate(getUrlBack(), {
          state: {
            from:
              location.state?.from === ROUTE_CLIENTS_RELATIONSHIP_REVIEW
                ? ROUTE_CLIENTS_RELATIONSHIP_REVIEW
                : "",
          },
        });
      });
  };

  useEffect(() => {
    document.title = "The Hub - Confidence History";

    return () => {
      resetScrollY(globalThis.location.pathname);
    };
  }, []);

  useEffect(() => {
    if (
      !ClientForHeaderInfo ||
      (ClientForHeaderInfo && ClientForHeaderInfo.id !== Number(id))
    )
      loadHeaderInfo(Number(id));
    loadConfidenceHistory();
  }, [ClientForHeaderInfo]);

  const getUrlBack = () => {
    return ROUTE_CLIENTS_RELATIONSHIP_KEY_CONTACT_DETAILS.replace(
      ":id",
      id ?? ""
    )
      .replace(":relationshipReviewId", relationshipReviewId ?? "")
      .replace(":keyContactId", keyContactId ?? "");
  };

  return (
    <div className="content">
      <HeaderClientsModule
        showBackButton={false}
        isLoadingPage={isLoadingDataConfidence}
      />

      {isLoadingDataConfidence && (
        <Spinner
          style={{
            marginLeft: "40%",
            marginTop: "5%",
          }}
        />
      )}
      {!isLoadingDataConfidence && (
        <>
          <div
            className="button-header"
            style={{ width: "100%", padding: "20px 0 15px 25px" }}
          >
            <Link
              className="back-button-container d-flex text-decoration-none"
              to={getUrlBack()}
              state={{
                from:
                  location.state?.from === ROUTE_CLIENTS_RELATIONSHIP_REVIEW
                    ? ROUTE_CLIENTS_RELATIONSHIP_REVIEW
                    : "",
              }}
            >
              <BiLeftArrowAlt className="back-button-arrow mt-1" />
              <span className="back-button-text mt-1">
                Back to Contact Details
              </span>
            </Link>
          </div>
          {hasConfidenceHistory && (
            <PaginatedItems
              itemsPerPage={10}
              items={confidenceHistory}
              type={"stackholder"}
            />
          )}
        </>
      )}
    </div>
  );
};
